import { render } from "./Registro01Plan.vue?vue&type=template&id=10e00bd5&scoped=true"
import script from "./Registro01Plan.vue?vue&type=script&lang=js"
export * from "./Registro01Plan.vue?vue&type=script&lang=js"

import "@/assets/css/tarjetas.css?vue&type=style&index=0&id=10e00bd5&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e00bd5"]])

export default __exports__